import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ChatAltIcon, ClockIcon, TrashIcon } from '@heroicons/vue/outline';

import { useAuraStore } from '@/stores/modules/aura';
import { can } from '@/composables/useAuth';
import { Permission } from '@/types';
import { formatRelativeDate } from '@/utils/datetime';
import type { AuraConversation } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraSidebar',
  props: {
    isHistoryLoading: { type: Boolean, required: true }
  },
  emits: ["select", "create", "delete"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

/**
 * AuraSidebar - Sidebar with conversation history
 * Single Responsibility: Display and manage conversation list
 */
const { t } = useI18n();
const store = useAuraStore();

// Props


// Emits
const emit = __emit;

// Permissions
const canViewHistory = computed(() => can(Permission.VIEW_AURA_CONVERSATION));
const canCreateConversation = computed(() => can(Permission.CREATE_AURA_CONVERSATION));
const canDeleteConversation = computed(() => can(Permission.DELETE_AURA_CONVERSATION));

// Computed from store
const hasConversations = computed(() => store.conversations.length > 0);
const conversations = computed(() => store.conversations);
const currentConversationId = computed(() => store.currentConversation?.id || null);
// Handlers
const selectConversation = (conversation: AuraConversation) => {
    emit('select', conversation);
};

const createConversation = () => {
    emit('create');
};

const deleteConversation = (conversation: AuraConversation) => {
    emit('delete', conversation);
};

const __returned__ = { t, store, emit, canViewHistory, canCreateConversation, canDeleteConversation, hasConversations, conversations, currentConversationId, selectConversation, createConversation, deleteConversation, get ChatAltIcon() { return ChatAltIcon }, get ClockIcon() { return ClockIcon }, get TrashIcon() { return TrashIcon }, get formatRelativeDate() { return formatRelativeDate } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})